import React, { useRef, useState } from 'react'
import { PropTypes } from 'prop-types'
import classNames from 'classnames'

function Slider({ className, children }) {
  const [isDown, setIsDown] = useState(false)
  const [startX, setStartX] = useState(null)
  const [scrollLeft, setScrollLeft] = useState(null)
  const carouselRef = useRef(null)

  const wrapperClasses = classNames('slider', className)

  // Source: https://stackoverflow.com/questions/28576636/mouse-click-and-drag-instead-of-horizontal-scroll-bar-to-view-full-content-of-c/66313884#66313884
  const startDragging = (e) => {
    e.preventDefault()
    e.stopPropagation()
    if (!carouselRef.current) return
    setIsDown(true)
    setStartX(e.pageX - carouselRef.current.offsetLeft)
    setScrollLeft(carouselRef.current.scrollLeft)
  }

  const stopDragging = (e) => {
    e.preventDefault()
    e.stopPropagation()
    if (!carouselRef.current) return
    setIsDown(false)
    setStartX(null)
    setScrollLeft(null)
  }

  const onMove = (e) => {
    if (!isDown || !carouselRef.current) return
    e.preventDefault()
    e.stopPropagation()
    const x = e.pageX - carouselRef.current.offsetLeft
    const walk = x - startX
    carouselRef.current.scrollLeft = scrollLeft - walk
  }

  return (
    <div
      className={wrapperClasses}
      ref={carouselRef}
      onMouseDown={startDragging}
      onMouseUp={stopDragging}
      onMouseLeave={stopDragging}
      onMouseMove={onMove}
    >
      <div className="slider-items">{children}</div>
    </div>
  )
}

Slider.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
}

export default Slider
